module.exports = __webpack_public_path__ + "media/images/front/mp_logo-4d9d9c2f91fea89286bb78c41798a0ba.png";